import { useEffect, useState } from "react";
import api, { fmtDate } from "@/lib/api";
import { PageHeader, Loader, EmptyState } from "@/components/ui-kit";
import { Button } from "@/components/ui/button";
import { ChevronLeft, ChevronRight, CalendarDays } from "lucide-react";

const MONTHS = ["Janvier", "Février", "Mars", "Avril", "Mai", "Juin", "Juillet", "Août", "Septembre", "Octobre", "Novembre", "Décembre"];
const DOW = ["Lun", "Mar", "Mer", "Jeu", "Ven", "Sam", "Dim"];

export default function Agenda() {
  const [events, setEvents] = useState(null);
  const [cur, setCur] = useState(new Date());

  useEffect(() => { api.get("/agenda").then((r) => setEvents(r.data)); }, []);
  if (events === null) return <Loader />;

  const y = cur.getFullYear(), m = cur.getMonth();
  const first = new Date(y, m, 1);
  const startDow = (first.getDay() + 6) % 7; // Monday=0
  const daysInMonth = new Date(y, m + 1, 0).getDate();
  const cells = [];
  for (let i = 0; i < startDow; i++) cells.push(null);
  for (let d = 1; d <= daysInMonth; d++) cells.push(d);

  const evByDay = (d) => {
    const ds = new Date(y, m, d).toISOString().slice(0, 10);
    return events.filter((e) => (e.date || "").slice(0, 10) === ds);
  };

  return (
    <div>
      <PageHeader title="Agenda" subtitle="Échéances, réunions, tâches, congés & absences">
        <div className="flex items-center gap-2">
          <Button variant="outline" size="icon" onClick={() => setCur(new Date(y, m - 1, 1))} data-testid="agenda-prev"><ChevronLeft className="h-4 w-4" /></Button>
          <span className="font-head font-semibold w-40 text-center">{MONTHS[m]} {y}</span>
          <Button variant="outline" size="icon" onClick={() => setCur(new Date(y, m + 1, 1))} data-testid="agenda-next"><ChevronRight className="h-4 w-4" /></Button>
        </div>
      </PageHeader>

      <div className="rounded-xl border bg-white overflow-hidden">
        <div className="grid grid-cols-7 border-b bg-slate-50">
          {DOW.map((d) => <div key={d} className="p-2 text-center text-xs font-mono uppercase text-slate-500">{d}</div>)}
        </div>
        <div className="grid grid-cols-7">
          {cells.map((d, i) => (
            <div key={i} className="min-h-24 border-b border-r p-1.5 last:border-r-0">
              {d && (
                <>
                  <p className={`text-xs font-mono mb-1 ${new Date().toDateString() === new Date(y, m, d).toDateString() ? "font-bold text-brand-600" : "text-slate-400"}`}>{d}</p>
                  <div className="space-y-1">
                    {evByDay(d).slice(0, 3).map((e, j) => (
                      <div key={j} className="rounded px-1.5 py-0.5 text-[10px] font-medium text-white truncate" style={{ background: e.color }} title={e.titre}>{e.titre}</div>
                    ))}
                    {evByDay(d).length > 3 && <p className="text-[10px] text-slate-400">+{evByDay(d).length - 3}</p>}
                  </div>
                </>
              )}
            </div>
          ))}
        </div>
      </div>
      {events.length === 0 && <p className="text-sm text-slate-400 mt-4 text-center">Aucun évènement planifié pour le moment.</p>}
    </div>
  );
}
